export default __webpack_public_path__ + "static/media/logo (2).05c9e92e.png";